// extracted by mini-css-extract-plugin
module.exports = {"container":"Policy_container__R9FS_","title":"Policy_title__6FZI8"};